import React from "react";
import { Provider } from "react-redux";
import { PersistGate } from "redux-persist/integration/react";
import { ApolloProvider } from "@apollo/client";
import { ThemeProvider } from "@mui/material/styles";
import { CssBaseline, CircularProgress, Box } from "@mui/material";
import { I18nextProvider } from "react-i18next";
import { store, persistor } from "./core/store";
import { client } from "./core/apollo-client";
import { useDynamicTheme } from "@/theme/useDynamicTheme";
import { AppProvider } from "@/context/app";
import { AppInitializer } from "@/components/AppInitializer";
import i18n from "@/localize/index";
import { AppRouter } from "@/router";
import "./App.css";

// Theme Provider Wrapper Component
const ThemeProviderWrapper: React.FC<{ children: React.ReactNode }> = ({
  children,
}) => {
  const dynamicTheme = useDynamicTheme();

  console.log("dynamicTheme", dynamicTheme);
  return <ThemeProvider theme={dynamicTheme}>{children}</ThemeProvider>;
};

const App: React.FC = () => {
  return (
    <Provider store={store}>
      <PersistGate
        loading={
          <Box
            sx={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              height: "100vh",
            }}
          >
            <CircularProgress />
          </Box>
        }
        persistor={persistor}
      >
        <ApolloProvider client={client}>
          <I18nextProvider i18n={i18n}>
            <ThemeProviderWrapper>
              <CssBaseline />
              <AppProvider>
                <AppInitializer>
                  <AppRouter />
                </AppInitializer>
              </AppProvider>
            </ThemeProviderWrapper>
          </I18nextProvider>
        </ApolloProvider>
      </PersistGate>
    </Provider>
  );
};

export default App;
